/**
 * @fileoverview GET handler for the "/data_objects/:type_name/:object_id/unlinked_objects" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectIdUnlinkedObjects } from "./constants";
import type {
  CustomObjectsTypeNameObjectIdUnlinkedObjectsParams,
  CustomObjectsTypeNameObjectIdUnlinkedObjectsResponse,
} from "./types";
import { isCustomObjectsTypeNameObjectIdUnlinkedObjectsResponse } from "./validators";

export const getCustomObjectsTypeNameObjectIdUnlinkedObjects = reactQueryFetcherAdapter(
  customObjectsTypeNameObjectIdUnlinkedObjects,
  (
    signal: AbortSignal,
    {
      appGroupId,
      typeName,
      objectId,
      relKind,
      direction,
      targetTypeName,
      searchTerm,
      start = 0,
      limit = 12,
    }: CustomObjectsTypeNameObjectIdUnlinkedObjectsParams
  ): Promise<CustomObjectsTypeNameObjectIdUnlinkedObjectsResponse> => {
    // The backend contract guarantees zero rows for a blank search term, so skip the request
    // (typeahead consumers mount with an empty term before the user types).
    if (searchTerm.trim() === "") {
      return Promise.resolve({ hits: 0, results: [] });
    }

    return fetch<CustomObjectsTypeNameObjectIdUnlinkedObjectsResponse>(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}/unlinked_objects`,
      "GET",
      {
        app_group_id: appGroupId,
        rel_kind: relKind,
        direction,
        target_type_name: targetTypeName,
        search_term: searchTerm,
        start,
        limit,
      },
      { signal }
    );
  },
  isCustomObjectsTypeNameObjectIdUnlinkedObjectsResponse
);
